module.exports = __webpack_public_path__ + "static/media/FrankRuhlLibre_900Black.84e7a277.ttf";